import Clicking from '~/bootcamp/Activities/Fractions/Bootcamp1/FractionNumParts/Clicking'

import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import FractionCompareDenomEqual from './FractionCompareDenomEqual/FractionCompareDenomEqual'
import FractionCompareDenomEqualFigures from './FractionCompareDenomEqualFigures/FractionCompareDenomEqualFigures'
import FractionCompareNumEqual from './FractionCompareNumEqual/FractionCompareNumEqual'
import FractionDenomInput from './FractionDenomInput/FractionDenomInput'
import FractionDivideZero from './FractionDivideZero/FractionDivideZero'
import FractionFigures from './FractionFigures/FractionFigures'
import FractionIllustrated from './FractionIllustrated/FractionIllustrated'
import FractionName from './FractionName/FractionName'
import FractionNumInput from './FractionNumInput/FractionNumInput'
import FractionPizza from './FractionPizza/FractionPizza'
import FractionTypes from './FractionTypes/FractionTypes'
import FractionTypes2 from './FractionTypes2/FractionTypes2'
import ImproperFraction from './ImproperFraction/ImproperFraction'
import ProperFraction from './ProperFraction/ProperFraction'
import FractionVisualize from './FractionVisualize/FractionVisualize'

const Bootcamp1Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'FractionName':
      return <FractionName {...props} />
    case 'FractionPizza1':
      return <FractionPizza {...props} type={1} />
    case 'FractionPizza2':
      return <FractionPizza {...props} type={2} />
    case 'FractionIllustrated':
      return <FractionIllustrated {...props} />
    case 'FractionFigures':
      return <FractionFigures {...props} />
    case 'FractionNumParts':
      return <Clicking {...props} />
    case 'FractionCompareNumEqual':
      return <FractionCompareNumEqual {...props} />
    case 'FractionNumInput':
      return <FractionNumInput {...props} />
    case 'FractionDenomInput':
      return <FractionDenomInput {...props} />
    case 'FractionCompareDenomEqualFigures':
      return <FractionCompareDenomEqualFigures {...props} />
    case 'FractionCompareDenomEqual':
      return <FractionCompareDenomEqual {...props} />
    case 'ProperFraction':
      return <ProperFraction {...props} />
    case 'ImproperFraction':
      return <ImproperFraction {...props} />
    case 'FractionTypes':
      return <FractionTypes {...props} />
    case 'FractionTypes2':
      return <FractionTypes2 {...props} />
    case 'FractionDivideZero':
      return <FractionDivideZero {...props} />
    case 'FractionVisualize':
      return <FractionVisualize {...props} />
    default:
      return <></>
  }
}

export default Bootcamp1Activities
